import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { StyledBookAMeetingLoadingScreen } from "./book-a-meeting-loading-screen.scss";
import { withGenericConfig } from "../../../../generic-config-context";
import { LOADING_SCREEN_IMAGE, LOADING_SCREEN_IMAGE_ALT } from "./book-a-meeting-loading-screen-consts";
const BookAMeetingLoadingScreen = (props)=>{
    const { translate } = props;
    return /*#__PURE__*/ _jsxs(StyledBookAMeetingLoadingScreen, {
        children: [
            /*#__PURE__*/ _jsx("img", {
                src: LOADING_SCREEN_IMAGE,
                alt: LOADING_SCREEN_IMAGE_ALT,
                className: "loading-screen-image"
            }),
            /*#__PURE__*/ _jsx("h2", {
                className: "loading-screen-text",
                children: translate("forms.loadingPage.hangTight")
            }),
            /*#__PURE__*/ _jsx("h2", {
                className: "loading-screen-text",
                children: translate("forms.loadingPage.getting")
            })
        ]
    });
};
export default withGenericConfig(BookAMeetingLoadingScreen);
